import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import type { SpaceGqlModel } from '../../gql/SpaceGqlModel'
import { Box, IconButton } from '@mui/material'
import { NewItemButton } from './NewItemButton.tsx'
import './SelectedSpaceHeader.css'
import { iconButtonSx } from '@/common/react/ui/IconButton'

interface SelectedSpaceHeaderProps {
  selectedSpace: SpaceGqlModel
  onClick: () => void
}

export function SelectedSpaceHeader({ selectedSpace, onClick }: SelectedSpaceHeaderProps) {
  return (
    <>
      <Box
        data-testid="selected-space-header"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          userSelect: 'none',
          // px: 0,
        }}
      >
        <Box
          className="selectedSpaceHeaderBlock"
          sx={{
            px: 1,
            ml: 1,
            gap: 1.5,
          }}
        >
          <IconButton sx={iconButtonSx} onClick={onClick}>
            <ArrowBackIcon fontSize="small" />
          </IconButton>
          <span style={{ fontSize: '16px', fontWeight: 500, alignSelf: 'center' }}>
            {selectedSpace.name}
          </span>
        </Box>
        <NewItemButton />
      </Box>
    </>
  )
}
